import { Card, Input, DatePicker, Row, Col } from "antd";
import { ReactComponent as CalendarIcon } from "../../Icons/vuesax/calendar.svg";
import { Dayjs } from "dayjs";

interface PatientFilterProps {
  selectedFirstName?: string;
  selectedLastName?: string;
  selectedMRN?: string;
  selectedDOB?: Dayjs | null;
  onFirstNameChange: (value: string) => void;
  onLastNameChange: (value: string) => void;
  onMRNChange: (value: string) => void;
  onDOBChange: (value: Dayjs) => void;
}

const PatientFilter = ({
    selectedFirstName = "",
    selectedLastName = "",
    selectedMRN = "",
    selectedDOB = null,
    onFirstNameChange,
    onLastNameChange,
    onMRNChange,
    onDOBChange
  }: PatientFilterProps) => {
  return (
    <Card
      styles={{ body: {padding: "16px"} }} 
      className={`service-filter-card`}>
      <span className="patient-filter-title">
        Patient
      </span>
      <Row gutter={[8,12]} style={{ marginTop: '10px' }}>
        <Col xs={24} sm={12}>
          <label htmlFor="first-name" className="input-label">
            First Name
          </label>
          <Input
            id="first-name"
            value={selectedFirstName}
            onChange={(e) => onFirstNameChange(e.target.value)}
            className="filter-input"
            placeholder="First Name"
          />
        </Col>
        <Col xs={24} sm={12}>
          <label htmlFor="last-name" className="input-label">
            Last Name
          </label>
          <Input
            id="last-name"
            value={selectedLastName}
            onChange={(e) => onLastNameChange(e.target.value)}
            className="filter-input"
            placeholder="Last Name"
          />
        </Col>
        <Col xs={24} sm={12}>
          <label htmlFor="mrn" className="input-label">
            MRN
          </label>
          <Input
            id="mrn"
            value={selectedMRN}
            onChange={(e) => onMRNChange(e.target.value)}
            className="filter-input"
            placeholder="MRN"
          />
        </Col>
        <Col xs={24} sm={12}>
          <label htmlFor="dob" className="input-label">
            DOB
          </label>
          <DatePicker
            id="dob"
            className="filter-input"
            value={selectedDOB}
            placeholder="MM/DD/YYYY"
            format="MM/DD/YYYY"
            suffixIcon={<CalendarIcon className="calendar-icon" />}
            onChange={onDOBChange}
          />
        </Col>
      </Row>
    </Card>
  );
};

export default PatientFilter;
